/**
 * Handle flyout menu JS for main menu.
 */
const handleFlyoutMenu = () => {
  const menuItems = document.querySelectorAll<HTMLElement>( '[data-parent="true"]' )
  menuItems.forEach( menuItem => {
    const link = menuItem.querySelector( 'a' )
    const submenu = menuItem.querySelector<HTMLElement>( '.submenu' )
    const submenuChildren = ( submenu ) ? submenu.querySelectorAll( 'li' ) : []
    const submenuHeight = submenu?.offsetHeight
    const button = menuItem.querySelector( 'button' )
    menuItem.addEventListener( 'mouseover', () => {
      menuItem.classList.add( 'open' )
      if ( link ) link.setAttribute( 'aria-expanded', 'true' )
      if ( button ) button.setAttribute( 'aria-expanded', 'true' )
      if ( submenu ) {
        submenu.classList.remove( 'hidden' )
        const submenuHeight = menuItem?.offsetHeight
        const submenuCalculatedHeight = ( submenuChildren.length ) ? submenuHeight * submenuChildren.length : submenuHeight
        submenu.style.height = `${submenuCalculatedHeight + 16}px`
        submenu.style.opacity = '1'
        submenu.classList.remove( 'menu-hidden' )
        submenu.classList.add( 'menu-revealed' )
        submenu.classList.add( 'py-2' )
      }
    } )
    menuItem.addEventListener( 'mouseout', () => {
      menuItem.classList.remove( 'open' )
      if ( link ) link.setAttribute( 'aria-expanded', 'false' )
      if ( button ) button.setAttribute( 'aria-expanded', 'false' )
      if ( submenu ) {
        submenu.style.height = '0%'
        submenu.style.opacity = '1'
        submenu.classList.add( 'menu-hidden' )
        submenu.classList.remove( 'menu-revealed' )
        submenu.classList.remove( 'py-2' )
        // setTimeout( () => { submenu.classList.add( 'hidden' ) }, 250 )
      }
    } )
    if ( button ) {
      button.addEventListener( 'click', () => {
        menuItem.classList.toggle( 'open' )
        if ( submenu ) {
          submenu.style.height = '0%'
          submenu.style.opacity = '1'
          submenu.classList.add( 'menu-hidden' )
          submenu.classList.remove( 'menu-revealed' )
          submenu.classList.remove( 'py-2' )
          // setTimeout( () => { submenu.classList.toggle( 'hidden' ) }, 250 )
        }
      } )
    }
  } )

}

export default handleFlyoutMenu